import {
    Typography,
    Stack,
    InputAdornment,
    Divider,
    Grid,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    Table,
    Paper
} from '@mui/material'

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { FormProvider, RHFTextField } from '../components/hook-form';

import { useEffect, useState } from 'react';
import { Box } from '@mui/system';

//
// minimum wage
//
const PYG_SYMBOL              = 'PY₲';


export default function IRPCalculationDetail({calculatedTaxes}) {
    const formatter     = Intl.NumberFormat('es-PY');
    let totalTaxes      = 0;

    calculatedTaxes.forEach(row => {
        totalTaxes += row.amount;
    })

    console.log(calculatedTaxes);

    return (
    <Grid container sx={{p: 1}}> 
        <TableContainer component={Paper} >
        <Table sx={{ minWidth: 200 }} aria-label="spanning table">
            <TableHead>
            {/* <TableRow>
                <TableCell align="center" colSpan={3}>
                Tramo
                </TableCell>
            </TableRow> */}
            <TableRow>
                <TableCell colSpan={2}><strong>Tramo</strong></TableCell>
                <TableCell align="right"><strong>Monto ({PYG_SYMBOL})</strong></TableCell>
                {/* <TableCell align="right"><strong>Llevado al siguiente Tramo ({PYG_SYMBOL})</strong></TableCell> */}
            </TableRow>
            </TableHead>

            <TableBody>
                
            {calculatedTaxes.map((row) => (
                <TableRow key={row.percent_tax}>
                <TableCell colSpan={2}>{row.percent_tax}%</TableCell>
                <TableCell align="right">{formatter.format(row.amount)}</TableCell>
                {/* <TableCell align="right">{formatter.format(row.carry_over)}</TableCell> */}
                </TableRow>
            ))}

            <TableRow>
                {/* <TableCell rowSpan={3} /> */}
                <TableCell colSpan={2} align="right"><i>Total de Impuestos</i></TableCell>
                <TableCell align="right"><i>{formatter.format(totalTaxes)}</i></TableCell>
            </TableRow>

            {/* <TableRow>
                <TableCell>Tax</TableCell>
                <TableCell align="right">{`${(12 * 100).toFixed(0)} %`}</TableCell>
                <TableCell align="right">{(123)}</TableCell>
            </TableRow>

            <TableRow>
                <TableCell colSpan={2}>Total</TableCell>
                <TableCell align="right">{(123)}</TableCell>
            </TableRow> */}
            
            </TableBody>
        </Table>
    </TableContainer>
   </Grid>
    );
}